import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

function FilterLayout({ title, children }) {
    return (
        <div className="field field--checkable-set">
            <h3 className="field__title">{title}</h3>
            <div className="field__children">{children}</div>
        </div>
    );
}

FilterLayout.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default observer(FilterLayout);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/FilterLayout.jsx